'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWidgetTypicalResponseTime = undefined;

var _reselect = require('reselect');

var _getTypicalResponseTime = require('conversations-schema/operators/widget-data/getTypicalResponseTime');

var _getLatestWidgetData = require('../../widget-data/selectors/getLatestWidgetData');

var getWidgetTypicalResponseTime = exports.getWidgetTypicalResponseTime = (0, _reselect.createSelector)([_getLatestWidgetData.getLatestWidgetData], _getTypicalResponseTime.getTypicalResponseTime);